<template>
  <div class="ai-chat-container">
    <div class="chat-header">
      <h2>AI智能写作助手</h2>
    </div>

    <!-- 聊天内容区域 -->
    <div class="chat-content" ref="chatContent" style="border: 2px solid blue">
      <!-- 历史对话气泡 -->
      <div
        v-for="(item, index) in chatHistory"
        :key="index"
        :class="['chat-item', item.role === 'user' ? 'user' : 'ai']"
      >
        <div class="chat-avatar">
          <img
            :src="
              item.role === 'user'
                ? 'https://q1.qlogo.cn/g?b=qq&nk=10000&s=100'
                : 'https://q1.qlogo.cn/g?b=qq&nk=20000&s=100'
            "
            alt=""
          />
        </div>
        <div class="chat-bubble">
          <div class="chat-text">{{ item.content }}</div>
        </div>
      </div>

      <!-- 正在生成的AI回复气泡 -->
      <div v-if="currentReply" class="chat-item ai">
        <div class="chat-avatar">
          <img src="https://q1.qlogo.cn/g?b=qq&nk=20000&s=100" alt="" />
        </div>
        <div class="chat-bubble">
          <div class="chat-text">{{ currentReply }}</div>
          <span v-if="loading" class="typing-dots">...</span>
        </div>
      </div>
    </div>
    <!-- 输入区域 -->
    <div class="chat-input-container" style="border: 4px solid red">
      <el-input
        type="textarea"
        v-model="inputMessage"
        placeholder="请输入你的问题..."
        class="chat-input"
        :disabled="loading"
        @keydown.enter.prevent="handleQuery"
      />
      <el-button
        type="info"
        class="chat-send-btn"
        @click="handleQuery"
        :loading="loading"
      >
        发送
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chatHistory: [], // 完整聊天历史
      currentReply: "", // 正在流式输出的AI回复
      inputMessage: "", // 输入框内容
      loading: false,
    };
  },
  methods: {
    // 自动滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.chatContent;
        el.scrollTop = el.scrollHeight;
      });
    },

    async handleQuery() {
      if (!this.inputMessage.trim()) return;

      // 1. 先把用户消息加入历史
      this.chatHistory.push({
        role: "user",
        content: this.inputMessage,
      });
      this.scrollToBottom();

      // 2. 初始化状态
      this.loading = true;
      this.currentReply = "";
      const userQuestion = this.inputMessage;
      this.inputMessage = "";

      try {
        // 3. 发送流式请求
        const response = await fetch(
          "http://192.168.3.194:5050/api/v1/AI/qwen/chat/stream",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              message: userQuestion,
              temperature: 0.7,
              max_tokens: 1500,
            }),
          },
        );

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          const chunk = decoder.decode(value, { stream: true });
          const lines = chunk.split("\n");

          for (const line of lines) {
            if (!line.trim()) continue;
            if (line.startsWith("data: ")) {
              const dataStr = line.replace("data: ", "").trim();
              if (dataStr === "[DONE]") continue;

              try {
                const data = JSON.parse(dataStr);
                if (data.content) {
                  // 逐字输出 + 控制速度
                  for (let c of data.content) {
                    this.currentReply += c;
                    this.scrollToBottom(); // 边输出边滚动
                    await new Promise((r) => setTimeout(r, 60));
                  }
                }
                if (data.done) break;
              } catch (e) {}
            }
          }
        }

        // 4. 流式结束，把当前回复推入历史
        this.chatHistory.push({
          role: "ai",
          content: this.currentReply,
        });
        this.currentReply = "";
        this.scrollToBottom();
      } catch (err) {
        this.$message.error("生成失败：" + err.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.ai-chat-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-width: 800px;
  margin: 0 auto;
  background: #f5f7fa;
}

.chat-header {
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  text-align: center;
}

.chat-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.chat-content {
  /* flex: 1; */
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.chat-item {
  display: flex;
  gap: 12px;
  max-width: 70%;
}

.chat-item.user {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.chat-avatar img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.chat-bubble {
  padding: 12px 16px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  position: relative;
}

.chat-item.user .chat-bubble {
  background: #8b5cf6;
  color: #fff;
}

.chat-text {
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
}

.typing-dots {
  display: inline-block;
  margin-left: 4px;
  animation: typing 1.4s infinite steps(4);
}

@keyframes typing {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

.chat-input-container {
  display: flex;
  padding: 16px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
}

.chat-input {
  flex: 1;
}

.chat-send-btn {
  align-self: flex-end;
  height: 40px;
  padding: 0 24px;
  border-radius: 20px;
  background: #8b5cf6;
  border: none;
  border: 4px solid red;
}
</style>
